<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<!-- Este layout no tiene header, así que dentro de la app móvil su contenido llegaría
  hasta el borde superior de la pantalla, por debajo de la status bar. Fuera de la app
  `--bp-safe-top` vale 0 y no cambia nada. -->
<div class="flex flex-col flex-auto w-full pt-safe-top pb-safe-bottom">

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

</div>
